import React from "react";

import { AccordionDetails } from "@mui/material";

import Accordion from "@rui/Accordion";
import { Column } from "@rui/Stack";

import { AccordionSummary } from "./styles";
import { UpsellModuleProps } from "./UpsellModule";
import UpsellModuleInnerContent from "./UpsellModuleInnerContent";

interface UpsellModuleAccordionProps
  extends Omit<UpsellModuleProps, "color" | "cta" | "onDismiss"> {
  actions: React.ReactNode;
}

const UpsellModuleAccordion = ({
  title,
  img,
  content,
  actions,
  sx,
}: UpsellModuleAccordionProps) => {
  return (
    <Accordion sx={{ background: "transparent", ...sx }}>
      <AccordionSummary>{title}</AccordionSummary>
      <AccordionDetails>
        <Column gap={1}>
          <UpsellModuleInnerContent img={img}>
            {content}
          </UpsellModuleInnerContent>
          {actions}
        </Column>
      </AccordionDetails>
    </Accordion>
  );
};

export default UpsellModuleAccordion;
